import * as React from 'react';
import {Box} from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Text from '../../../ui/Text';

interface Props {
  title: string;
  subtitle: string;
  icon: React.ReactNode;
}

const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const ModalItem: React.FC<Props> = ({icon, title, subtitle}) => {
  const s = useStyles();
  return (
    <Box mb={3} className={s.wrapper}>
      <Box>{icon}</Box>
      <Box ml={1}>
        <Box>
          <Text fs="18" bold>
            {title}
          </Text>
        </Box>
        <Box mt={0.5}>
          <Text fs="14" lh="16">
            {subtitle}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default ModalItem;
